var map = {
	"./ammiraglio/ammiraglio 1.jpeg": "2213",
	"./ammiraglio/ammiraglio 2.jpeg": "2620",
	"./ammiraglio/ammiraglio 3.jpeg": "45cc",
	"./ammiraglio/ammiraglio 4 bagno.jpeg": "2feb",
	"./ammiraglio/ammiraglio 5.jpeg": "7894",
	"./ammiraglio/ammiraglio 6.jpeg": "5028",
	"./ammiraglio/ammiraglio 7 bagno.jpeg": "64c6",
	"./ammiraglio/ammiraglio 8 .jpeg": "e856",
	"./ammiraglio/ammiraglio 9 bagno.jpeg": "d162",
	"./ammiraglio/ammiraglio10.jpeg": "30e8",
	"./anto_milo.jpeg": "f966",
	"./award_2020.png": "f826",
	"./capitano/capitano 1.jpeg": "4eaf",
	"./capitano/capitano 2.jpeg": "06e0",
	"./capitano/capitano 3.jpeg": "8f37",
	"./capitano/capitano 4.jpeg": "9274",
	"./capitano/capitano 5 bagno.jpeg": "175c",
	"./cibo/arancini.jpeg": "dcbd",
	"./cibo/bollitore.jpeg": "2489",
	"./cibo/colazione_1.jpeg": "fec6",
	"./cibo/colazione_1.jpeg.old.jpeg": "e44b",
	"./cibo/colazione_2.jpeg": "53b1",
	"./cibo/colazione_3.jpeg": "d9f8",
	"./cibo/colazione_4.jpeg": "8fcb",
	"./cibo/colazione_5.jpeg": "c8a5",
	"./cibo/colazione_6.jpeg": "2ae7",
	"./cibo/vino.jpeg": "67f4",
	"./dettagli/dettaglio bagno 2.jpeg": "74b3",
	"./dettagli/dettaglio bagno.jpeg": "c2e0",
	"./dettagli/dettaglio chiavi 2.jpeg": "0db0",
	"./dettagli/dettaglio chiavi.jpeg": "b9dc",
	"./dettagli/servizi 2.jpeg": "32b7",
	"./dettagli/servizi.jpeg": "999c",
	"./dettagli/set cortesia 2.jpeg": "8c42",
	"./dettagli/set cortesia.jpeg": "dbfe",
	"./mozzo/mozzo 2.jpeg": "405d",
	"./mozzo/mozzo 3.jpeg": "246a",
	"./mozzo/mozzo 5 balcone.jpeg": "7c55",
	"./mozzo/mozzo1.jpeg": "89c6",
	"./mozzo/mozzo6.jpeg": "1e9d",
	"./nostromo/nostromo 1.jpeg": "1436",
	"./nostromo/nostromo 2.jpeg": "5a6b",
	"./nostromo/nostromo 3.jpeg": "c68f",
	"./nostromo/nostromo 4 bagno.jpeg": "c7ab",
	"./nostromo/nostromo 5 balcone.jpeg": "8052",
	"./oblo/corridoio 1.jpeg": "9503",
	"./oblo/corridoio 2.jpeg": "c932",
	"./oblo/corridoio 3.jpeg": "4102",
	"./oblo/corridoio 4.jpeg": "943b",
	"./oblo/paesaggio 1.jpeg": "8fd7",
	"./oblo/paesaggio 2.jpeg": "e3f8",
	"./oblo/paesaggio 2_med.jpeg": "b876",
	"./oblo/paesaggio 3.jpeg": "c4a9",
	"./oblo/paesaggio 4.jpeg": "90fb",
	"./oblo/paesaggio5.jpeg": "2b51",
	"./oblo/piazza 1.jpeg": "73a0",
	"./oblo/piazza 2.jpeg": "1907",
	"./oblo/reception 1.jpeg": "4f13",
	"./oblo/reception 2.jpeg": "581e",
	"./oblo/reception_fix.jpg": "5bbd",
	"./promo/cenone_capodanno.png": "ee4c",
	"./promo/promo_49.jpeg": "6534",
	"./promo/promo_49.png": "dd06",
	"./promo/s_agata.jpg": "1ecd",
	"./promo/santagata.jpeg": "6853",
	"./promo/sanvalentino.jpeg": "0917",
	"./thumbs/ammiraglio_min.jpeg": "f0f0",
	"./thumbs/capitano_min.jpeg": "e768",
	"./thumbs/mozzo_min.jpeg": "3df2",
	"./thumbs/nostromo_min.jpeg": "ad3d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";